import { IOption } from "models/problem";

export const getTotalSteps = (problemsCount: number): number => {
  if (problemsCount < 1) {
    return 0;
  }
  return problemsCount * 2 + 2;
};

export const getAnswerStatus = (
  userAnswer: number,
  options: IOption[]
): boolean => {
  const answer = options.find((item) => item.id === userAnswer);
  if (answer) return true;
  return false;
};

export const calculateScore = (score: number) => {
  if (score < 0) return 0;
  const fixedScore = ((score * 5) / 100).toFixed(1);
  return parseFloat(fixedScore);
};
